<template>
  <div class="md-layout scroll-y exercicse-view">
    <div class="md-layout-item md-small-size-100 md-size-17"></div>
    <div id="print" class="md-layout-item md-small-size-100 md-size-66 mb-10 mt-10">
      <!-- back btn -->
      <v-btn small :to="prevUrl || `/exercises`" tile elevation="0" color="transparent" style="color: #000" class="pl-0 pr-0 mb-5">
        <v-icon>mdi-arrow-left</v-icon>
        Retour
      </v-btn>

      <form id="print" ref="content">
        <v-card>
          <!-- toolbar -->
          <v-toolbar dark color="#0F1547">
            <v-toolbar-title> Exercice {{ exo.title }} </v-toolbar-title>
            <template v-slot:extension>
              <div class="row">
                <div class="md-layout-item md-size-33" v-if="exo.destinationType">
                  <label class="white-label" v-if="exo.destinationType === DestinationTypes.UNDEFINED">ERREUR</label>
                  <label class="white-label" v-else-if="exo.destinationType === DestinationTypes.PUBLIC">Destination: Transversal</label>
                  <label class="white-label" v-else-if="exo.destinationType === DestinationTypes.FEDERAL">Destination: Fédéral</label>
                  <label class="white-label" v-else-if="exo.destinationType === DestinationTypes.DISCIPLINE">Destination: Spécifique</label>
                  <label class="white-label" v-else-if="exo.destinationType === DestinationTypes.COACH">Destination: Entraineur</label>
                  <label class="white-label" v-else>Valeur non prise en charge</label>
                </div>

                <div class="md-layout-item md-size-33">
                  <label v-if="exo.exerciseType" class="white-label">Type: {{ exerciseTypeItems.find((e) => e.value === exo.exerciseType).text }}</label>
                </div>
              </div>
            </template>

            <v-spacer></v-spacer>

            <v-btn class="d-print-none" v-on:click="download" style="color: #0f1547" color="#fff">
              <v-icon class="mr-2">mdi-printer</v-icon>
              Imprimer
            </v-btn>
          </v-toolbar>

          <!-- Picture Preview -->
          <v-img v-if="exo.preview" :src="exo.preview"></v-img>
          <!-- Image -->
          <v-img
            v-else-if="medias[0] && (medias[0].image || medias[0].isImage) && !medias[0].src && !medias[0].videoOptions"
            style="height: auto; max-width: 100%; margin: 0"
            :src="medias[0].image"
          ></v-img>
          <!-- Video -->
          <video-player
            v-else-if="medias[0] && (medias[0].videoOptions || medias[0].youtube)"
            style="height: auto; width: 100%; margin: 0"
            :options="medias[0].videoOptions"
          ></video-player>
          <!-- IFrame -->
          <iframe v-else-if="medias[0] && medias[0].canal" style="height: auto; max-width: 100%; margin: 0" :src="medias[0].src"></iframe>
          <!-- Link -->
          <a v-else-if="medias[0] && medias[0].src" :href="medias[0].src" target="_blank">{{ medias[0].src }}</a>

          <v-card-text>
            <v-row v-if="exo.preview">
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-row v-if="exo.descriptionHtml || exo.instructionsHtml || exo.materielHtml">
              <v-col cols="4" v-if="exo.descriptionHtml">
                <v-label>Description</v-label>
                <p v-html="exo.descriptionHtml" />
              </v-col>

              <v-col cols="4" v-if="exo.instructionsHtml">
                <v-label>Instructions</v-label>
                <p v-html="exo.instructionsHtml" />
              </v-col>

              <v-col cols="4" v-if="exo.materielHtml">
                <v-label>Matériel</v-label>
                <p v-html="exo.materielHtml" />
              </v-col>
            </v-row>

            <v-row v-if="exo.realisation || exo.prerequis || exo.variables">
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>

              <v-col cols="4" v-if="exo.realisation">
                <v-label>Critéres de réalisation</v-label>
                <p>{{ exo.realisation }}</p>
              </v-col>
              <v-col cols="4" v-if="exo.prerequis">
                <v-label>Prérequis</v-label>
                <p>{{ exo.realisation }}</p>
              </v-col>
              <v-col cols="4" v-if="exo.variables">
                <v-label>Variables</v-label>
                <p>{{ exo.variables }}</p>
              </v-col>
            </v-row>

            <v-row
              v-if="
                (exo.experienceLevels && exo.experienceLevels.length > 0) ||
                (exo.workForms && exo.workForms.length > 0) ||
                (exo.advancedMode && exo.exerciseSkills && exo.exerciseSkills.length > 0)
              "
            >
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>

              <v-col cols="4" v-if="exo.experienceLevels && exo.experienceLevels.length > 0">
                <v-label>{{ experienceLevelCustomTitle }}</v-label>
                <v-row>
                  <v-col class="no-padding-sides">
                    <v-chip v-for="experienceLevel in exo.experienceLevels" class="ma-2" :key="experienceLevel.id">
                      {{ experienceLevel.title }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="4" v-if="exo.workForms && exo.workForms.length > 0">
                <v-label>{{ workFormCustomTitle }}</v-label>
                <v-row>
                  <v-col class="no-padding-sides">
                    <v-chip v-for="workForm in exo.workForms" class="ma-2" :key="workForm.id">
                      {{ workForm.title }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4" v-if="exo.advancedMode && exo.exerciseSkills && exo.exerciseSkills.length > 0">
                <v-label>{{ skillCustomTitle }}</v-label>
                <v-row>
                  <v-col class="no-padding-sides">
                    <v-chip v-for="skill in exo.skills" class="ma-2" :key="skill.id">
                      {{ skill.title }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>

          <v-row v-if="medias && medias.length > 0">
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>

            <v-col cols="12">
              <div class="d-inline-flex flex-wrap flex-row">
                <div v-for="obj in medias" style="display: inline !important; width: 320px; padding: 10px" :key="obj.id">
                  <v-card
                    @click="
                      dialog = true;
                      selected = obj;
                    "
                  >
                    <img :src="obj.image" />
                    <v-card-text>{{ obj.name }}</v-card-text>
                  </v-card>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </form>
    </div>
    <div class="md-layout-item md-size-17">
      <v-dialog v-model="dialog">
        <v-card style="height: 800px !important" v-if="selected" class="mx-auto">
          <video-player :options="selected.videoOptions" :key="0" v-if="selected.typeId == 2 || selected.youtube" style="height: 600px !important"></video-player>
          <v-img v-else-if="selected.typeId == 1 || selected.isImage" :src="selected.image" :contain="true" height="600px" max-width="600px"></v-img>
          <iframe v-else-if="selected.typeId == 4 && selected.canal" :src="selected.src" style="height: 600px !important"></iframe>
          <a v-else-if="selected.typeId == 4" :href="selected.src" target="_blank">{{ selected.src }}</a>

          <div class="md-layout-item md-medium-size-50 md-size-90 ma">
            <v-form>
              <v-label>{{ selected.name }}</v-label>

              <v-card-actions>
                <v-btn v-if="selected.typeId == 3">
                  <a :href="selected.file">Télécharger</a>
                </v-btn>
              </v-card-actions>
            </v-form>
            <!--<v-list-item v-for="(exo, i) in shares" :key="i"></v-list-item>-->
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { getDownloadMediaByPathAsync } from "@/api/mediaApi";
import { getExerciseByIdAsync } from "@/api/exerciseApi";
import VideoPlayer from "@/components/VideoPlayer";
import { getDisciplineAsync } from "@/api/disciplinesApi";
import store from "@/store";
import { ExerciseType } from "@/models/enums";
import { DestinationType } from "@/models/enums";
import AuthService from "@/services/AuthService";
import PermissionsService from "@/services/PermissionsService";

export default {
  name: "exerciseView",

  props: {
    id: {
      type: String,
    },
    item: {
      type: Object,
      default: function () {
        return {
          preview: undefined,
        };
      },
    },
  },

  components: {
    VideoPlayer,
  },

  data() {
    return {
      authService: AuthService,
      exo: {},
      reloader: 0,
      isReal: false,
      isPrerequis: false,
      margins: {
        top: 0,
        bottom: 40,
        left: 30,
        width: 550,
      },
      medias: [],
      dialog: false,
      selected: null,
      prevUrl: null,
      experienceLevelCustomTitle: "",
      workFormCustomTitle: "",
      exerciseSkills: [],
      skillCustomTitle: "",
      exerciseTypeItems: [
        { text: "Exercice", value: ExerciseType.EXERCISE },
        { text: "Test (évaluation)", value: ExerciseType.EVALUATION },
        { text: "Situation de référence", value: ExerciseType.REFERENCE },
      ],
      DestinationTypes: DestinationType,
    };
  },

  computed: {
    canViewCurrentExercise() {
      // Can view own Exercises
      let canViewOwnExercises = PermissionsService.ExercisesPermissionsService.canViewOwnExercises;
      // Can view all Exercises
      let canViewAllExercises = PermissionsService.ExercisesPermissionsService.canViewAllExercises;
      return canViewOwnExercises || canViewAllExercises;
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevUrl = from.fullPath;
    });
  },

  async mounted() {
    this.exo = await getExerciseByIdAsync(this.id);

    // Check if the user can see this page
    if (!this.canViewCurrentExercise) {
      store.dispatch("setSnackbar", {
        title: `Non Autorisé`,
        text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
        status: "warning",
        timeout: 2000,
      });

      this.$router.replace("/");
    }

    this.reloader++;

    this.medias = await this.loadImage();

    // Empty only frontend experienceLevels property (used to handle ddl selected values)
    this.exo.experienceLevels = [];
    // Get all the many many exerciseExperienceLevels values and map only the experienceLevel id into experienceLevels (filling the ddl with values)
    this.exo.exerciseExperienceLevels.forEach((element) => {
      this.exo.experienceLevels.push(element.experienceLevel);
    });

    // Empty only frontend workForms property (used to handle ddl selected values)
    this.exo.workForms = [];
    // Get all the many many exerciseWorkForms values and map only the workForm id into workForms (filling the ddl with values)
    this.exo.exerciseWorkForms.forEach((element) => {
      this.exo.workForms.push(element.workForm);
    });

    // Empty only frontend skills property (used to handle ddl selected values)
    this.exo.skills = [];
    // Get all the many many exerciseSkills values and map only the skill id into skills (filling the ddl with values)
    this.exo.exerciseSkills.forEach((element) => {
      this.exo.skills.push(element.skill);
    });

    // If there is a related discipline, get the custom labels
    if (this.exo && this.exo.disciplineId) {
      await this.getDisciplineForCustomLabels();
    }
  },

  methods: {
    print() {
      window.print();
    },

    download() {
      // Get HTML to print from element
      const prtHtml = document.getElementById("print").innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open("", "", "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0");

      WinPrint.document.write(`
      <!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
          </head>
          <body>
            ${prtHtml}
          </body>
        </html>
      `);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
    },

    async loadImage() {
      let list = [];
      this.exo.exerciseMedia.forEach((e) => {
        list.push(e.media);
      });
      const toReturn = [];
      for (let i = 0; i < list.length; i++) {
        let url = list[i].url;
        if (url) {
          const urlCreator = window.URL || window.webkitURL;
          let response;
          let result;
          switch (list[i].typeId) {
            case 1:
              response = await getDownloadMediaByPathAsync(url);
              if (!response) break;
              result = await response.blob();
              list[i].image = urlCreator.createObjectURL(result);
              toReturn.push({
                id: list[i].id,
                src: urlCreator.createObjectURL(result),
                alt: list[i].name,
              });
              break;
            case 2:
              response = await getDownloadMediaByPathAsync(url);
              if (!response) break;
              result = await response.blob();
              list[i].image = require("@/assets/Placeholder_video.jpg");
              list[i].videoOptions = {
                techOrder: ["html5", "youtube"],
                autoplay: false,
                controls: true,
                responsive: true,
                sources: [
                  {
                    src: urlCreator.createObjectURL(result),
                    type: response.headers.get("Content-Type"),
                  },
                ],
              };
              toReturn.push({
                id: list[i].id,
                src: require("@/assets/Placeholder_video.jpg"),
                alt: list[i].name,
              });

              break;
            case 3:
              response = await getDownloadMediaByPathAsync(url);
              if (!response) break;
              result = await response.blob();
              list[i].image = require("@/assets/Placeholder_fichier.jpg");
              list[i].file = urlCreator.createObjectURL(result);
              toReturn.push({
                id: list[i].id,
                src: require("@/assets/Placeholder_fichier.jpg"),
                alt: list[i].name,
              });
              break;
            case 4:
              list[i].image = require("@/assets/Placeholder_lien.jpg");
              const parse = require("url-parse");
              const parsed = parse(url, true);
              const youtubeRegex = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/gim;
              const pictureRegex = /http[s]?:\/\/.+\.(jpeg|png|jpg|gif)/gim;
              list[i].src = url;
              if (parsed.hostname.includes("canal-sport") && parsed.pathname.endsWith("player")) list[i].canal = true;
              else if (youtubeRegex.exec(url)) {
                list[i].youtube = true;
                list[i].videoOptions = {
                  techOrder: ["html5", "youtube"],
                  autoplay: false,
                  controls: true,
                  responsive: true,
                  sources: [
                    {
                      src: url,
                      type: "video/youtube",
                    },
                  ],
                };
              } else if (pictureRegex.exec(url)) {
                list[i].isImage = true;
                list[i].image = url;
              }

              toReturn.push({
                id: list[i].id,
                src: require("@/assets/Placeholder_lien.jpg"),
                alt: list[i].name,
              });
              break;
            default:
              break;
          }
        }
      }

      return list;
    },

    // Get the current discipline to use the custom Experience Level title and the workform custom title
    async getDisciplineForCustomLabels() {
      if (this.exo && this.exo.disciplineId) {
        var currentDiscipline = await getDisciplineAsync(this.exo.disciplineId);

        if (!currentDiscipline) {
          store.dispatch("setSnackbar", {
            title: "Erreur",
            text: "Impossible de récupérer la discipline auprès du serveur",
            status: "error",
            timeout: 5000,
          });
        } else {
          // experience level
          this.experienceLevelCustomTitle = currentDiscipline.experienceLevelCustomTitle ? currentDiscipline.experienceLevelCustomTitle : "Niveaux de pratique";

          // workform
          this.workFormCustomTitle = currentDiscipline.workFormCustomTitle ? currentDiscipline.workFormCustomTitle : "Formes de travail";

          // skills
          this.skillCustomTitle = currentDiscipline.skillCustomTitle ? currentDiscipline.skillCustomTitle : "Compétences";
        }
      }
    },
  },
};
</script>

<style>
.exercicse-view .v-label {
  color: rgb(15, 21, 71);
  font-weight: bold;
}

.theme--light.v-treeview .v-treeview-node--disabled {
  color: #000 !important;
}

.rotateimg90 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

@media print {
  body {
    overflow: auto;
    height: auto;
  }

  .scroll-y {
    height: auto;
    overflow: visible;
  }

  p {
    font-size: 13px !important;
    color: black !important;
  }

  @page {
    size: landscape;
  }
}
</style>

<style lang="scss" scoped>
.white-label {
  color:white;
  border: none !important;
  cursor: default !important;
}
</style>
